import type { TopDestination } from './schemas'

export abstract class TopDestinationsRepository {
  abstract getAll(lang: string): Promise<TopDestination[]>
}
